import { render, staticRenderFns } from "./S4.vue?vue&type=template&id=06bcb928&scoped=true&"
import script from "./S4.vue?vue&type=script&lang=js&"
export * from "./S4.vue?vue&type=script&lang=js&"
import style0 from "./S4.vue?vue&type=style&index=0&id=06bcb928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bcb928",
  null
  
)

component.options.__file = "S4.vue"
export default component.exports